import React from "react";
import { Link, useParams } from "react-router-dom";
import { roleByKey } from "../../helpers/roles";

/**
 * Страница роли: что это, кому подходит, что даёт, как войти.
 *
 * Максим 21.08.2026: «Открыть роль» не отправляет заявку, а открывает
 * описание роли — возможности и уникальные свойства. Раньше кнопка вела в
 * никуда, и человек не понимал, на что соглашается, нажимая её.
 *
 * Полные описания живут в справочнике проекта, здесь короткая выжимка и
 * ссылка на него: так тексты не разъедутся при первой же правке справочника.
 */

const PUBLIC = process.env.PUBLIC_URL || "";

const RolePage = () => {
  const { key } = useParams();
  const role = roleByKey(key);

  if (!role) {
    return (
      <div className="fw-page">
        <Link className="fw-back" to={`${PUBLIC}/profile`}>
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M15 18l-6-6 6-6" />
          </svg>
          К ролям
        </Link>
        <h1 className="fw-title">Роль не найдена</h1>
        <p className="fw-sub">
          Возможно, ссылка устарела. Откройте список ролей в профиле и выберите заново.
        </p>
      </div>
    );
  }

  return (
    <div className="fw-page">
      <Link className="fw-back" to={`${PUBLIC}/profile`}>
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M15 18l-6-6 6-6" />
        </svg>
        К ролям
      </Link>

      <div className="fw-role-head">
        <span className="ic">{role.icon}</span>
        <div>
          <h1 className="fw-title">{role.title}</h1>
          <p className="fw-sub mb-0">{role.who}</p>
        </div>
      </div>

      <section className="fw-card fw-box">
        <h3>Кому подходит</h3>
        <p className="fw-note mb-0">{role.fits}</p>
      </section>

      <section className="fw-card fw-box">
        <h3>Что можно делать</h3>
        <ul className="fw-role-list">
          {(role.can || []).map((item) => (
            <li key={item}>{item}</li>
          ))}
        </ul>
      </section>

      <section className="fw-card fw-box">
        <h3>Что это даёт</h3>
        <p className="fw-note mb-0">{role.gives}</p>
      </section>

      <section className="fw-card fw-box">
        <h3>Как открыть</h3>
        <p className="fw-note">{role.entry}</p>

        {/* Два пути: пройти игровую локацию и получить награду, открывающую
            роль, либо купить за монеты FDP. Ссылок на локации и цен нам пока
            не дали, поэтому каждая кнопка показывается только тогда, когда
            под ней есть настоящий адрес: кнопка в никуда хуже её отсутствия. */}
        <div className="fw-role-acts">
          {role.questUrl && (
            <a className="fw-btn" href={role.questUrl} target="_blank" rel="noreferrer">
              Пройти локацию и получить роль
            </a>
          )}

          {role.priceFdp && (
            <button type="button" className="fw-btn ghost">
              Купить за {role.priceFdp} FDP
            </button>
          )}

          <a className="fw-btn ghost" href={role.doc} target="_blank" rel="noreferrer">
            Подробное описание роли →
          </a>
        </div>

        {!role.questUrl && !role.priceFdp && (
          <p className="fw-sec-sub mt-3 mb-0">
            Способы открыть эту роль скоро появятся здесь: игровая локация и покупка
            за монеты FDP.
          </p>
        )}
      </section>
    </div>
  );
};

export default RolePage;
